import Readmore from 'readmore-js/dist/readmore.js'
import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

turbolinksLoadedObservable.subscribe(() => {
  // eslint-disable-next-line no-new
  new Readmore('[data-readmore-block]', {
    moreLink: '<a href="#" class="readmore-block-button__more">Read more</a>',
    lessLink: '<a href="#" class="readmore-block-button__less">Close</a>',
  })
})
